(function (ws) {
    'use strict';
    ws.routers.simpleTable = Backbone.Router.extend({

        /**
         * Routes
         */
        routes: {
            catalog: 'catalog',
            '': 'default'
        }

    });
})(westcon);
